import { useEffect, useState, ReactElement } from "react";

import FlexColumn from "../../layout/Flexbox/FlexColumn";
import FlexRow from "../../layout/Flexbox/FlexRow";

import "./TextInput_style.css";

type Props = Readonly<{
    id?: string;
    label?: string | null;
    value: string;
    onChange?: (val: string) => void;
    style?: React.CSSProperties;
    password?: boolean;
    onEnterKeyPress?: () => void;
    placeholderText?: string | null;
}>;

export default function TextInput({id = undefined, label = null, value, onChange, style, password, onEnterKeyPress, placeholderText}: Props): ReactElement {
    const [textValue, setTextValue] = useState<string>(value);
    const [isPasswordField, _] = useState<boolean>(
        password !== undefined ? password : false
    );

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            onEnterKeyPress?.();
        }
    };

    return (
        <div id={id} className="text-input-component" style={style}>
            <FlexColumn gap={8}>
                {label != null && (<p className="input-label">{label}</p>)}
                <div className="text-input">
                    <input 
                        className="input-field"
                        name="text-input-field"
                        type={isPasswordField ? "password" : "text"}
                        value={textValue}
                        onKeyDown={(event) => {
                            handleKeyDown(event);
                        }}
                        onChange={(event) => {
                            setTextValue(() => {
                                const newValue = event.target.value;
                                onChange?.(newValue);
                                return newValue;
                            });
                        }}
                    />
                    {placeholderText == null || textValue.length > 0 ? 
                        null : 
                        <p className="placeholder-text">
                            {placeholderText}
                        </p>
                    }
                </div>
            </FlexColumn>
        </div>
    );
}
